import { ReservationConfirmationResult as ReservationConfirmationResultDto } from 'gleblu-socket-api';

import ReservationConfirmationResult from '../interfaces/ReservationConfirmationResult';

export function fromDto(dto: ReservationConfirmationResultDto): ReservationConfirmationResult {
  return ReservationConfirmationResult[dto];
}

export function toDto(_: ReservationConfirmationResult): ReservationConfirmationResultDto {
  throw new Error('Not supported');
}
